import React from 'react';
import { motion } from 'framer-motion';
import { X, AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-6 bg-darknavy relative" data-id="element-143">
      <div className="max-w-2xl mx-auto space-y-24" data-id="element-144">
        {/* No estás mal */}
        <div className="space-y-8" data-id="element-145">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-146">
            <h2 className="text-3xl md:text-4xl font-heading text-cream mb-6" data-id="element-147">
              No estás “mal”. Estás en modo vigilancia.
            </h2>
            <div className="space-y-4 text-lg text-cream-dim leading-relaxed" data-id="element-148">
              <p data-id="element-149">
                Si eres una mujer que durante el día resuelve cosas, cuida
                gente, trabaja, sostiene… tu cerebro aprendió que{' '}
                <span className="text-amber" data-id="element-150">anticipar es sobrevivir.</span>
              </p>
              <p data-id="element-151">
                El problema es que a las 3AM esa habilidad se convierte en
                sabotaje.
              </p>
              <p className="font-medium text-cream text-xl border-l-4 border-amber pl-6 py-2 my-8 bg-midnight/30 rounded-r-lg" data-id="element-152">
                Porque el sueño no se negocia. <br data-id="element-153" />
                El sueño se permite.
              </p>
              <p data-id="element-154">
                Y cuando tú intentas forzarlo, el cuerpo interpreta: “hay
                peligro”.
                <br data-id="element-155" />
                Resultado: más alerta, más pensamiento, más tiempo despierta.
              </p>
            </div>
          </motion.div>
        </div>

        {/* La Trampa */}
        <div className="space-y-8" data-id="element-156">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-midnight p-8 rounded-2xl border border-white/5 shadow-xl" data-id="element-157">
            <div className="flex items-start gap-4 mb-6" data-id="element-158">
              <AlertCircle className="w-8 h-8 text-amber-dark shrink-0" data-id="element-159" />
              <h2 className="text-2xl md:text-3xl font-heading text-cream" data-id="element-160">
                La trampa: pelearte con tus pensamientos
              </h2>
            </div>

            <p className="text-lg text-cream-dim mb-6" data-id="element-161">
              A las 3AM haces lo que cualquier persona inteligente haría:
              intentas resolverlo.
            </p>

            <ul className="space-y-3 mb-8 ml-2" data-id="element-162">
              {['“Tengo que dormir ya.”', '“No puedo pensar.”', '“Mañana tengo…”', '“¿Y si esto me pasa siempre?”'].map((item, i) => <li key={i} className="flex items-center gap-3 text-warmgray italic" data-id="element-163">
                  <span className="w-1.5 h-1.5 rounded-full bg-amber/50" data-id="element-164" />
                  {item}
                </li>)}
            </ul>

            <p className="text-lg text-cream-dim" data-id="element-165">
              Y sin darte cuenta, le estás diciendo a tu sistema nervioso:
              <br data-id="element-166" />
              <span className="text-amber font-heading text-xl block mt-2" data-id="element-167">
                “Esto es importante. Mantente despierta.”
              </span>
            </p>
          </motion.div>
        </div>

        {/* No necesitas tips */}
        <div className="space-y-8" data-id="element-168">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-169">
            <h2 className="text-3xl md:text-4xl font-heading text-cream mb-8 text-center" data-id="element-170">
              Lo que necesitas no es otra lista de tips
            </h2>

            <div className="grid gap-4 mb-10" data-id="element-171">
              {['otra recomendación genérica de “no uses pantallas”', 'otra rutina de 30 pasos', 'otra meditación larga (que a esa hora no te da la cabeza)', 'sentirte culpable por “hacerlo mal”'].map((item, i) => <div key={i} className="flex items-center gap-4 text-warmgray/80 line-through decoration-amber/50 decoration-2" data-id="element-172">
                  <X className="w-5 h-5 text-amber-dark shrink-0" data-id="element-173" />
                  <span data-id="element-174">{item}</span>
                </div>)}
            </div>

            <div className="text-center space-y-4" data-id="element-175">
              <p className="text-xl text-cream" data-id="element-176">
                Necesitas algo que puedas hacer medio dormida, en piloto
                automático.
              </p>
              <p className="text-2xl md:text-3xl font-heading text-amber" data-id="element-177">
                Un protocolo corto. Repetible. Humano.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}